var React = require('react');
var ReactNative = require('react-native');
var createReactClass = require('create-react-class');

var { View } = ReactNative;

var WebView = createReactClass(
{
  setNativeProps : function() {},

  render : function()
  {
    return <View style={this.props.style}>{this.props.children}</View>
  }
});

module.exports = WebView;
